module.exports = __webpack_public_path__ + "static/img/10.7849417.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/sp/10.png
// module id = vWGw
// module chunks = 0